import React from 'react';

interface GroupPreviewProps {
  groupName: string;
  department: string;
  personnel: { id: number; name: string }[];
}

const GroupPreview = ({ groupName, department, personnel }: GroupPreviewProps) => {
  return (
    <div className="space-y-3">
      <h3 className="text-lg font-semibold text-blue-600">Group Preview</h3>

      <div className="flex gap-20">
        <div>
          <p className="text-sm text-gray-500">Group Name</p>
          <p className="font-medium text-[#13294B]">{groupName}</p>
        </div>
        <div>
          <p className="text-sm text-gray-500">Department</p>
          <p className="font-medium text-[#13294B]">{department}</p>
        </div>
      </div>

      <div>
        <p className="text-sm text-gray-500 mb-3">Group Personnel</p>

        <div className="border border-gray-300 rounded-xl overflow-hidden">
          <table className="w-full">
            <thead>
              <tr className="border-b border-gray-300">
                <th className="w-[100px] py-4 border-r border-gray-300 text-sm font-medium text-gray-600">Sl. No.</th>
                <th className="text-left px-6 py-4 text-sm font-medium text-gray-600">Shift Attendants & Assistants</th>
              </tr>
            </thead>
          </table>

          <div className="max-h-48 overflow-y-auto">
            <table className="w-full">
              <tbody>
                {personnel.map((person, index) => (
                  <tr key={person.id} className="border-b border-gray-300 last:border-b-0 h-10">
                    <td className="w-[100px] text-center border-r border-gray-300 text-gray-500">{index + 1}</td>
                    <td className="px-6">
                      <div className="flex items-center gap-3">
                        <div className="w-8 h-8 rounded-full bg-gray-200 flex items-center justify-center text-xs font-medium text-gray-600">
                          {person.name?.charAt(0)?.toUpperCase() || '?'}
                        </div>
                        <span className="font-medium text-[#13294B]">{person.name}</span>
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
};

export default GroupPreview;
